export default "__VITE_ASSET__CQ2iw9cm__"